import PropTypes from 'prop-types';

var propTypes = {
    settingsLinks: PropTypes.arrayOf(PropTypes.object).isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeSettingsMenu: PropTypes.func.isRequired,
    onSelectLink: PropTypes.func.isRequired,
    userName: PropTypes.string.isRequired,
    photoUrl: PropTypes.string,
    avatarColor: PropTypes.string,
    userNameInitials: PropTypes.string.isRequired,
    userAddress: PropTypes.string,
    userInfo: PropTypes.string,
};
var defaultProps = {
    isOpen: false,
    settingsLinks: [],
};

export { defaultProps, propTypes };
